import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { EventTypesList } from "../eventTypes/EventTypesList";

export const EventTypesPage: FC = () => {
	return (
		<Routes>
			<Route index element={<EventTypesList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
